// extracted by mini-css-extract-plugin
export default {"page":"gVf0A","header":"PPLzG","formInner":"gmd2_","inner":"c0lXt","form":"xzTWO","errorMessage":"asS6W","actions":"QRmoi","action":"j7PVi"};